<form [formGroup]="form">
	<lvr-section-form>
		@let schoolCtrl = form.get('schoolId');
		<lvr-field
			[label]="'client.career.school' | transloco | appendAsterisk"
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
		>
			<mat-form-field lvrInput [lvrError]="hasError(schoolCtrl, 'required')">
				<input
					matInput
					formControlName="schoolSearch"
					[placeholder]="'base.field.select_please' | transloco"
					aria-required="true"
					[matAutocomplete]="autoComp"
					(focus)="onInputFocus()"
				/>
				<mat-autocomplete
					#autoComp="matAutocomplete"
					(optionSelected)="schoolSelected($event)"
					autoActiveFirstOption
					[displayWith]="displaySchool"
					[attr.aria-busy]="isLoadingSuggestions()"
				>
					@if (!isLoadingSuggestions()) {
						@for (option of suggestions(); track option.id) {
							<mat-option [value]="option">
								<span>{{ option.name }}</span
								><br />
								<span class="secondary">
									{{ option.schoolNumber }}
								</span>
							</mat-option>
						}
					}
					@if (isLoadingSuggestions()) {
						<mat-option disabled [attr.aria-label]="'global_search.searching' | transloco">
							@if (showLoadingSuggestions()) {
								<mat-progress-bar mode="indeterminate" aria-hidden="true"></mat-progress-bar>
								<span>{{ 'global_search.searching' | transloco }}</span>
							}
						</mat-option>
					}
					@if (showNoSuggestions()) {
						<mat-option disabled> {{ 'client.career.no_school_suggestion' | transloco }} </mat-option>
					}
				</mat-autocomplete>

				@if (hasError(schoolCtrl, 'required')) {
					<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
				}
			</mat-form-field>
		</lvr-field>

		<!-- Institution City District -->
		@let cityDistrictCtrl = form.get('cityDistrictId');
		<lvr-field
			[label]="'base.field.school_district' | transloco | appendAsterisk"
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
		>
			<lvr-searchable-select
				formControlName="cityDistrictId"
				[options]="cityDistricts()"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'base.field.no_results' | transloco"
				[ariaLabel]="'base.field.residence_district' | transloco"
				[required]="true"
				[hasError]="hasError(cityDistrictCtrl, 'required')"
				[errorMessage]="'client.career.error.required' | transloco"
			></lvr-searchable-select>
		</lvr-field>

		<!-- career orientation start year Field (begin des orientierungsjahrs) -->
		@let careerOrientationStartYearCtrl = form.get('careerOrientationStartYear');
		<lvr-field
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
			[matTooltip]="'client.career.careerOrientationStartYear_hint' | transloco"
			[label]="'client.career.careerOrientationStartYear' | transloco | appendAsterisk"
		>
			<mat-form-field lvrInput [lvrError]="hasError(careerOrientationStartYearCtrl, 'min', 'max', 'required')">
				<input
					matInput
					formControlName="careerOrientationStartYear"
					placeholder="2010"
					type="number"
					[min]="minMaxYear.min"
					[max]="minMaxYear.max"
					aria-required="true"
					[errorStateMatcher]="matcher"
				/>
				@if (hasError(careerOrientationStartYearCtrl, 'min')) {
					<mat-error>{{ 'client.career.error.min' | transloco: { min: 10 } }}</mat-error>
				}
				@if (hasError(careerOrientationStartYearCtrl, 'max')) {
					<mat-error>{{ 'client.career.error.max' | transloco: { max: minMaxYear.max } }}</mat-error>
				}
				@if (hasError(careerOrientationStartYearCtrl, 'required')) {
					<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
				}
			</mat-form-field>
		</lvr-field>

		<!-- Remark Field (Beschreibung) -->
		@let remarkCtrl = form.get('remark');
		<lvr-field lvrPadding [padHorizontal]="16" [padVertical]="0" [label]="'base.field.remark' | transloco">
			<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'maxLength')">
				<textarea
					matInput
					formControlName="remark"
					placeholder="Weitere Informationen"
					[maxlength]="env.formConfiguration.career.remarkLength"
					[errorStateMatcher]="matcher"
				></textarea>
				@if (hasError(remarkCtrl, 'maxLength')) {
					<mat-error>{{
						'client.career.error.maxLength' | transloco: { max: env.formConfiguration.career.remarkLength }
					}}</mat-error>
				}
				<mat-hint>{{
					'client.career.socialSecurityStatusRemarkHint'
						| transloco: { actual: remarkCtrl?.value?.length || 0, max: env.formConfiguration.career.remarkLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>
	</lvr-section-form>
</form>
